import React from "react";
import { Link } from 'react-router-dom'
function Home() {
        return(
         <div>
    <header className="header">
        <div className="container">
          
            <div className="header-content">
                <h4 className="header-subtitle" >Hello, I am</h4>
                <h1 className="header-title">Chetan.K</h1>
                <h6 className="header-mono" >Frond end Designer | Developer</h6>
               
            </div>
        </div>
  </header>

  <section class="section bg-dark py-5">
        <div class="container text-center">
            <h2 class="text-light mb-5 font-weight-normal">I Am Available For FreeLance</h2>
          <Link to="/Contact">  <button class="btn bg-primary w-lg" >Contact Me</button> </Link>
        </div>
    </section>
    
{/* portfolio */}
<div className="scrollblock">
         <div className="container-fluid pt-10">
            <div className="row justify-content-md-center ">
               <div className="col-md-10 col-sm-12">
                  <div className="card-columns">
                     <div className="card card-hover h-100" >
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/chetan.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p> </p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="card card-hover h-100" >
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/header.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p></p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="card card-hover h-100">
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/chetan6.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p></p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="card card-hover h-100">
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/chetan7.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p></p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="card card-hover h-100">
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/chetan5.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p></p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="card card-hover h-100">
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/chetan4.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p></p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="card card-hover h-100">
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/chetan3.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p></p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="card card-hover h-100">
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/chetan2.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p></p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                     <div className="card card-hover h-100">
                        <div className="card-body">
                           <Link to="/">
                              <img className="card-img-top" src="assets/imgs/chetan1.jpg" alt="Card image cap"/>
                              <div className="reveal h-100 p-2 d-flex ">
                                 <div className="w-100 align-self-center">
                                    <p></p>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>



        </div>)
    }

export default Home